import React from 'react';
import './Services.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const ServiceCard = ({ img, title, items, index }) => {
  const cardRef = useScrollAnimation(index * 100);
  
  return (
    <div ref={cardRef} className="service-card-wrapper animate-on-scroll animate-fade-in-up">
      <div className="service-icon">
        <img src={img} alt={`${title} Icon`} />
      </div>
      <div className="service-card">
        <h3 className="service-title">{title}</h3>
        <ul className="service-list">
          {items.map((item, idx) => <li key={idx}>{item}</li>)}
        </ul>
      </div>
    </div>
  );
};

const Services = () => {
  const headerRef = useScrollAnimation(100);
  
  const servicesData = [
    {
      img: "/Screenshot_1.png",
      title: "المحتوى الأبداعي",
      items: [
        'كتابة المحتوى الابداعي',
        'التفاعل الابداعي مع الجمهور',
        'التصوير الفوتوغرافي للمنتجات',
        'ابتكار حملات إبداعية متكاملة',
        'إنتاج المحتوى المرئي الإبداعي'
      ]
    },
    {
      img: "/Screenshot_2.png",
      title: "التسويق الرقمي بالحملات",
      items: [
        'حملات الإعلانات المدفوعة (Facebook, Instagram, Google)',
        'حملات الإعلانات المدفوعة (Ads, TikTok)',
        'حملات التسويق عبر المؤثرين',
        'حملات البريد الإلكتروني',
        'حملات إعادة الاستهداف'
      ]
    },
    {
      img: "/Screenshot_3.png",
      title: "الأستشارات التسويقية",
      items: [
        'أبحاث السوق وتحليل المنافسين',
        'تحديد الشرائح المستهدفة',
        'صياغة استراتيجيات العلامة التجارية',
        'وضع مؤشرات الأداء الرئيسية',
        'استراتيجيات التسويق الرقمي المتكاملة'
      ]
    },
    {
      img: "/Screenshot_4.png",
      title: "الإعلانات الخارجية",
      items: [
        'لوحات الطرق',
        'الإعلانات في الشوارع و الساحات',
        'الإعلانات في المراكز التجارية',
        'الإعلانات على وسائل النقل (باصات، سيارات الأجرة، مترو)'
      ]
    },
    {
      img: "/Screenshot_5.png",
      title: "إدارة الحسابات وتحسين محركات البحث",
      items: [
        'إدارة حسابات التواصل الاجتماعي',
        'خدمة العملاء عبر المنصات الاجتماعية',
        'تحسين محركات البحث (On-page SEO)',
        'تحسين تجربة المستخدم لرفع الترتيب',
        'إعلانات الشوارع'
      ]
    },
    {
      img: "/Screenshot_6.png",
      title: "بناء وتطوير العلامات التجارية",
      items: [
        'تصميم الهوية البصرية',
        'صياغة الهوية اللفظية',
        'تطوير تجربة العلامة',
        'إعادة إطلاق العلامة التجارية',
        'بناء دليل العلامة التجارية',
        'تصميم التغليف والهويات الفرعية',
        'العلامة التجارية الشخصية'
      ]
    },
    {
      img: "/Screenshot_7.png",
      title: "الخدمات الرئيسية للعلاقات العامة والإعلام",
      items: [
        'إدارة السمعة و التواصل المؤسسي',
        'التواصل الأعلامي و الصحفي',
        'تنظيم الفعاليات و إدارة المعارض',
        'التدريب والتأهيل الإعلامي'
      ]
    },
    {
      img: "/Screenshot_8.png",
      title: "خدمات الدعاية والإعلان",
      items: [
        'الإعلانات المطبوعة',
        'الإعلانات التلفزيونية و الصوتية',
        'الإعلانات عبر الفعاليات و الرعايات',
        'الأعلان عبر الترويج الميداني'
      ]
    }
  ];

  return (
    <section id="services" className="services-section">
      <div ref={headerRef} className="services-header animate-on-scroll animate-fade-in-up">
        <h2 className="services-title">
          احصل على وصول فوري إلى مزودي خدمات موثوقين في مختلف المجالات
        </h2>
        <h2 className="services-title-2">
          اختر الأنسب لمشروعك وفق احتياجاتك الخاصة
        </h2>
      </div>

      <div className="services-cards">
        {servicesData.map((service, index) => (
          <ServiceCard
            key={index}
            img={service.img}
            title={service.title}
            items={service.items}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default Services;


